import { Progress } from 'foundations-components/transitional/components/Progress';
import PDFLoadingImageBackground from './PDFLoadingImageBackground';
import { jsx as _jsx } from "react/jsx-runtime";
const PDFLoading = ({
  pageIndex,
  imagePlaceholders,
  value = 0
}) => {
  return /*#__PURE__*/_jsx(PDFLoadingImageBackground, {
    pageIndex: pageIndex,
    imagePlaceholders: imagePlaceholders,
    children: /*#__PURE__*/_jsx("div", {
      style: {
        width: '250px'
      },
      children: /*#__PURE__*/_jsx(Progress, {
        marginBlockEnd: "0",
        value: value
      })
    })
  });
};
export default PDFLoading;